import * as actions from '../redux/actions';

import { ContactForm3, SearchBox2 } from '..';

import AboutUsIconSection3 from '../common/about-us/AboutUsIconSection3';
import HeroSection from '../common/HeroSection/HeroSection';
import MultiSlider3 from '../common/MultiSlider3/MultiSlider3';
import { OfficesList3 } from '../common/OfficeList/OfficesList3';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../functions/getIcons/getIcons';
import getSlides from '../functions/getSlides/getSlides';

// KennyBus
const kennybusIcon1 = '/assets/kennybus/icons/seat-icon.svg';
const kennybusIcon2 = '/assets/kennybus/icons/charging-icon.svg';
const kennybusIcon3 = '/assets/kennybus/icons/ticket-icon.svg';

// Viatur
const viaturIcon1 = '/assets/viatur/icons/seat.svg';
const viaturIcon2 = '/assets/viatur/icons/technology.svg';
const viaturIcon3 = '/assets/viatur/icons/mobile-ticket.svg';

const getIconsAndTexts = operator => {
	const name = operator && operator.operator_name;

	let icon1 = '';
	let icon2 = '';
	let icon3 = '';

	if (name === 'kennybus') {
		icon1 = kennybusIcon1;
		icon2 = kennybusIcon2;
		icon3 = kennybusIcon3;
	}

	if (name === 'viatur') {
		icon1 = viaturIcon1;
		icon2 = viaturIcon2;
		icon3 = viaturIcon3;
	}

	const aboutIconsAndTexts = [
		{
			icon: icon1,
			caption: 'Variedad de asientos',
			desc: 'Viaja cómodamente eligiendo entre asientos Semi cama o Salón cama.',
		},
		{
			icon: icon2,
			caption: 'Tecnología a bordo',
			desc: 'Aprovecha las comodidades y cargador USB de nuestros buses durante tu viaje.',
		},
		{
			icon: icon3,
			caption: 'Pasaje móvil',
			desc: 'Sube al bus mostrando tu pasaje en tu celular sin tener que imprimirlo.',
		},
	];

	return aboutIconsAndTexts;
};

const Theme3 = ({ operator, history }) => {
	const officeLocations = operator.office_data;
	const operatorName = operator && operator.operator_name ? operator.operator_name : '';

	const createMarkup = () => {
		return { __html: operator && operator.terms && operator.terms };
	};

	const getComponent = () => {
		if (operatorName === 'kennybus') {
			return (
				<div className="new-container" style={{ marginTop: 20 }}>
					<h2 style={{ fontSize: '30px', margin: '20px 0' }}>Obligaciones de los pasajeros</h2>
					<div
						dangerouslySetInnerHTML={createMarkup()}
						className=""
						style={{
							background:
								operator && operator.color_codes && operator.color_codes.secondary_color
									? operator.color_codes.secondary_color
									: '',
							color: 'white',
							padding: '20px',
							textAlign: 'justify',
							borderRadius: '0 0 10px 10px',
							fontSize: '15px',
							lineHeight: '1.3',

							// this is temporary  make this dynamic
							fontFamily: 'Cera_Pro_Medium',
						}}
					/>
				</div>
			);
		} else if (operatorName === 'viatur') {
			return (
				<MultiSlider3
					operator={operator}
					id="gallery"
					smallHeading="Gallery"
					multiSlides={getSlides('Gallery', operator)}
				/>
			);
		}
		return <div></div>;
	};

	return (
		<div className="themes-theme-3">
			<div style={{ position: 'relative' }}>
				<HeroSection height={'78vh'} heroImage={getIcons('Banner', operator)} />

				<div style={styles.searchBoxOverlay}>
					<SearchBox2 history={history} operator={operator} />
				</div>
			</div>

			<div className="new-container ">
				<MultiSlider3
					operator={operator}
					id="buses"
					smallHeading="Destinos"
					multiSlides={getSlides('Destination'.operator)}
				/>

				<AboutUsIconSection3
					id="features"
					smallHeading={'La empresa'}
					// boldHeading={'NUESTROS SERVICIOS'}
					iconsAndTexts={getIconsAndTexts(operator)}
					aboutText
				/>

				<OfficesList3 officeLocations={officeLocations} operator={operator} />

				{getComponent()}
				<ContactForm3 id="contact" operator={operator} />
			</div>
		</div>
	);
};
/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

const styles = {
	searchBoxOverlay: {
		position: 'absolute',
		height: '100%',
		width: '100%',
		// top: 0,
		top: '80px',
		zIndex: 10,
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
	},
};

export default connect(mapStateToProps, mapDispatchToProps)(Theme3);



// WEBPACK FOOTER //
// ./src/features/themes/theme3/Theme3.js